import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IListingSearchResponse, IPoiSearchResponse, ISearchAutocompleteRequest } from '@curbnturf/entities';
import { objectToUrlParams } from '@curbnturf/helpers';
import { Observable } from 'rxjs';
import { BASE_API_URL } from '../network/api-config';

const API_URL = BASE_API_URL + 'search';

/**
 * Local fork of @curbnturf/search-components' SearchService — trimmed to
 * plain HttpClient and to the autocomplete methods the navbar search box
 * actually calls. The real class depends on CachedHttpClient
 * (@curbnturf/network), which pulls in AlertFacade -> NgRx Store; cnt-landing
 * no longer runs NgRx (see app.config.ts), so that chain threw NG0201 as
 * soon as NavbarComponent injected it. searchForPoi/searchForPoiPrefix/
 * poiIndexStatistics/listingIndexStatistics/recreateIndexes aren't used.
 */
@Injectable({ providedIn: 'root' })
export class SearchApiService {
  private readonly http = inject(HttpClient);

  searchForPoiAutocomplete(query: ISearchAutocompleteRequest): Observable<IPoiSearchResponse> {
    return this.http.get<IPoiSearchResponse>(`${API_URL}/poi-autocomplete?${objectToUrlParams(query)}`);
  }

  searchForListingAutocomplete(query: ISearchAutocompleteRequest): Observable<IListingSearchResponse> {
    return this.http.get<IListingSearchResponse>(`${API_URL}/listing-autocomplete?${objectToUrlParams(query)}`);
  }
}
